import { Link } from 'react-router-dom';
import { ArrowRight, Globe, Users, BookOpen, Heart } from 'lucide-react';
import { Button } from '../components/ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../translations';

const Home = () => {
  const { language } = useLanguage();
  const t = translations[language];

  const testimonials = [
    {
      id: 1,
      name: t.testimonials.t1.name,
      location: t.testimonials.t1.location,
      text: t.testimonials.t1.text,
      rating: 5
    },
    {
      id: 2,
      name: t.testimonials.t2.name,
      location: t.testimonials.t2.location,
      text: t.testimonials.t2.text,
      rating: 5
    },
    {
      id: 3,
      name: t.testimonials.t3.name,
      location: t.testimonials.t3.location,
      text: t.testimonials.t3.text,
      rating: 5
    }
  ];

  return (
    <div className="home-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <h1 className="hero-title">
            {t.home.heroTitle}
          </h1>
          <p className="hero-subtitle">
            {t.home.heroSubtitle}
          </p>
          <div className="hero-buttons">
            <Link to="/programme">
              <Button className="btn-primary">
                {t.home.discoverProgram}
                <ArrowRight className="ml-2" size={20} />
              </Button>
            </Link>
            <Link to="/contact">
              <Button className="btn-secondary">
                {t.home.contactUs}
              </Button>
            </Link>
          </div>
        </div>
      </section>

      {/* Vision Section */}
      <section className="section-container">
        <div className="section-content">
          <h2 className="section-title">{t.home.visionTitle}</h2>
          <p className="section-text">
            {t.home.visionText}
          </p>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-section">
        <div className="section-container">
          <h2 className="section-title">{t.home.whyTitle}</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <Globe size={32} />
              </div>
              <h3>{t.home.feature1Title}</h3>
              <p>{t.home.feature1Text}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Users size={32} />
              </div>
              <h3>{t.home.feature2Title}</h3>
              <p>{t.home.feature2Text}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <BookOpen size={32} />
              </div>
              <h3>{t.home.feature3Title}</h3>
              <p>{t.home.feature3Text}</p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <Heart size={32} />
              </div>
              <h3>{t.home.feature4Title}</h3>
              <p>{t.home.feature4Text}</p>
            </div>
          </div>
        </div>
      </section>

      {/* How It Works */}
      <section className="section-container how-it-works">
        <h2 className="section-title">{t.home.howTitle}</h2>
        <div className="steps-container">
          <div className="step-card">
            <div className="step-number">1</div>
            <h3>{t.home.step1Title}</h3>
            <p>{t.home.step1Text}</p>
          </div>

          <div className="step-card">
            <div className="step-number">2</div>
            <h3>{t.home.step2Title}</h3>
            <p>{t.home.step2Text}</p>
          </div>

          <div className="step-card">
            <div className="step-number">3</div>
            <h3>{t.home.step3Title}</h3>
            <p>{t.home.step3Text}</p>
          </div>

          <div className="step-card">
            <div className="step-number">4</div>
            <h3>{t.home.step4Title}</h3>
            <p>{t.home.step4Text}</p>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="testimonials-section">
        <div className="section-container">
          <h2 className="section-title">{t.home.testimonialsTitle}</h2>
          <div className="testimonials-grid">
            {testimonials.map((testimonial) => (
              <div key={testimonial.id} className="testimonial-card">
                <div className="testimonial-stars">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <span key={i}>★</span>
                  ))}
                </div>
                <p className="testimonial-text">"{testimonial.text}"</p>
                <div className="testimonial-author">
                  <p className="author-name">{testimonial.name}</p>
                  <p className="author-location">{testimonial.location}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2 className="cta-title">{t.home.ctaTitle}</h2>
          <p className="cta-text">
            {t.home.ctaText}
          </p>
          <Link to="/contact">
            <Button className="btn-cta">
              {t.home.ctaButton}
              <ArrowRight className="ml-2" size={20} />
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Home;